var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"option-el",class:{
    'state-disabled': _vm.isDisabled,
    'state-selected': _vm.isSelected,
  },on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.selectOption.apply(null, arguments)}}},[_vm._t("default",null,{"selected":_vm.isSelected})],2)}
var staticRenderFns = []

export { render, staticRenderFns }